module.exports = __webpack_public_path__ + "img/aboutPage_service_icon33.4e832fde.png";